import React, { useState, useEffect } from "react";
import "./EducationPage.css";

const EducationPage = () => {
  const [activeTab, setActiveTab] = useState("world");
  const [fade, setFade] = useState(true);

  const tabs = [
    { key: "world", label: "World Schools" },
    { key: "school", label: "Public Schools" },
    { key: "college", label: "Colleges" },
    { key: "university", label: "Universities" },
  ];

  const changeTab = (tab) => {
    if (tab === activeTab) return;

    setFade(false);

    setTimeout(() => {
      setActiveTab(tab);
      setFade(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 250);
  };

  useEffect(() => {
    const cards = document.querySelectorAll(".card-wrapper");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          } else {
            entry.target.classList.remove("show");
          }
        });
      },
      {
        threshold: 0.45,
        rootMargin: "0px 0px -150px 0px",
      }
    );

    cards.forEach((card) => observer.observe(card));

    return () => {
      cards.forEach((card) => observer.unobserve(card));
    };
  }, [activeTab]);

  const data = {
    world: [
      {
        title: "TIGWS - Siliguri",
        desc: (
          <p>
            "Probably the flagship school in the wide network of academic excellence by Techno India
            Group, TIG World School – Siliguri, was nominated for the <i>Educational Excellence
              Award For Emerging International School</i> at the <strong>Red FM North Bengal Business
                Awards 2026</strong>. Blessed with state-of-the-art educational facilities and a dedicated
            faculty, the institution stands tall as the most trusted, girls-only, boarding school in
            Eastern India. Here, students not only excel in academics, but also come out with flying
            colours in co-curricular activities and are being trained to develop a global outlook
            alongside compassion towards society and empathy for nature. ​”
          </p>
        ),
        img: "/images/",
        link: "https://tigworldschools.com/siliguri"
      },
      {
        title: "TIGWS - Malda",
        desc: (
          <p>
            "Techno India Group World School – Malda, operates on a modern and scientific
            approach towards learning & development. Here, the students not only get the global
            standard of education, but also enjoy a much-needed exposure to a wide range of co-
            scholastic activities. Our faculty par excellence, leave no stone unturned to make young
            learners future-ready and help them acquire must-have skills like critical thinking,
            analytical prowess and leadership qualities. TIG World School – Malda, also boasts of an
            in-house, career counselling team that curate pathways for the citizens of tomorrow. ​”
          </p>
        ),
        img: "/images/",
        link: "https://tigworldschools.com/malda"
      },
      {
        title: "TIGWS - Kolkata",
        desc: (
          <p>
            "Been in the academics for more than four decades now, Techno India Group continues to
            expand its already-vast network of premium educational institutions and TIG World
            School – Kolkata, happens to be the latest addition to the long and elusive list. The
            construction work is currently underway and the school is being built around the core
            ideas of holistic approach, advanced learning methods and humane values like empathy,
            moral responsibility towards society and nature. TIGWS – Kolkata will open soon and is
            expected to be a distinguished centre of excellence that caters to the dynamic needs of the
            fast-changing, tech-first, global academic landscape. ​”
          </p>
        ),
        img: "/images/",
        link: "https://tigworldschools.com/kolkata"
      },
    ],

    school: [
      {
        title: "TIGPS - Alipurduar",
        desc: (
          <p>
            "TIGPS Alipurduar is a CBSE-affiliated co-educational English medium school established in 2015 in Alipurduar. The school's vision is to shape future-ready individuals equipped to face the challenges of the modern world.”        </p>
        ),
        img: "/images/ecosystem/Alipurduar.jpg",
        link: "https://alipurduar.tigps.in/"
      },
      {
        title: "TIGPS - Bolpur",
        desc: (
          <p>
            "TIGPS Bolpur is a CBSE-affiliated modern school located in Bolpur, West Bengal, near the abode of Nobel Laureate Rabindranath Tagore. Established in 2008, the school provides a state-of-the-art.”
          </p>
        ),
        img: "/images/ecosystem/Bolpur.jpg",
        link: "https://bolpur.tigps.in/"
      },
      {
        title: "TIGPS - Coochbehar",
        desc: (
          <p>
            "TIGPS Coochbehar is a prestigious CBSE-affiliated school located in Coochbehar, West Bengal. Established in 2008, the school provides a nurturing environment for students to grow intellectually and aesthetically.”
          </p>
        ),
        img: "/images/ecosystem/Coochbehar.jpg",
        link: "https://coochbehar.tigps.in/"
      },
      {
        title: "TIGPS - Durgapur",
        desc: (
          <p>
            "TIGPS Durgapur is a CBSE-affiliated co-educational English medium school established in 2015 in Durgapur, West Bengal. The school aims to shape the future of students through innovative education.”
          </p>
        ),
        img: "/images/ecosystem/Durgapur.jpg",
        link: "https://durgapur.tigps.in/"
      },
      {
        title: "TIGPS - Falakata",
        desc: (
          <p>
            "TIGPS Falakata is a CBSE-affiliated co-educational English medium school established in 2014 in Falakata. The school aims to provide a nurturing environment for students to excel academically and develop holistically.”
          </p>
        ),
        img: "/images/ecosystem/Falakata.jpg",
        link: "https://falakata.tigps.in/"
      },
      {
        title: "TIGPS - Gangarampur",
        desc: (
          <p>
            "Techno India Group Public School Gangarampur, located in the Dakshin Dinajpur district of West Bengal, offers students modern amenities alongside a robust infrastructure.”
          </p>
        ),
        img: "/images/ecosystem/No-image.jpg",
        link: "https://gangarampur.tigps.in/"
      },
      {
        title: "TIGPS - Hooghly",
        desc: (
          <p>
            "TIGPS Hooghly is a CBSE-affiliated co-educational English medium school established in 2005 and located in Chinsurah, West Bengal. The school aims to provide a nurturing environment for students to excel academically.”
          </p>
        ),
        img: "/images/ecosystem/Hooghly.jpg",
        link: "https://hooghly.tigps.in/"
      },
      {
        title: "TIGPS - Jalpaiguri",
        desc: (
          <p>
            "TIGPS Jalpaiguri is a CBSE-affiliated co-educational English medium school established in 2013 in Jalpaiguri, West Bengal. The school aims to provide a nurturing environment for students to excel academically and develop holistically.”
          </p>
        ),
        img: "/images/ecosystem/Jalpaiguri.jpg",
        link: "https://jalpaiguri.tigps.in/"
      },
      {
        title: "TIGPS - Kolaghat",
        desc: (
          <p>
            " TIGPS Kolaghat is a CBSE-affiliated co-educational English medium school established in 2015 in Kolaghat, West Bengal. The school has a strong emphasis on academic excellence and aims to produce well-rounded individuals.”
          </p>
        ),
        img: "/images/ecosystem/Kolaghat.jpg",
        link: "https://kolaghat.tigps.in/"
      },
      {
        title: "TIGPS - Krishnanagar",
        desc: (
          <p>
            "Techno India Group Public School Krishnanagar was founded in 2019-2020, with a focus on world-class education support and holistic development of enthusiastic learners.The prestigious co-educational English medium institution pledges to foster academic excellence and help with character building.”
          </p>
        ),
        img: "/images/ecosystem/No-image.jpg",
        link: "https://hooghly.tigps.in/"
      },
      {
        title: "TIGPS - Kanchrapara",
        desc: (
          <p>
            "TIGPS Kanchrapara is a co-educational, English medium school, under CBSE curriculum. The school considers education to be a life-long process which needs a strong foundation. ”
          </p>
        ),
        img: "/images/ecosystem/No-image.jpg",
        link: "https://kanchrapara.tigps.in/"
      },
      {
        title: "TIGPS - Midnapore",
        desc: (
          <p>
            " TIGPS Midnapore is a CBSE-affiliated co-educational English medium school established in 2019 in Midnapore. It has a well-equipped campus with smart classrooms, activity rooms, and a focus on health and hygiene.”
          </p>
        ),
        img: "/images/ecosystem/Midnapore.jpg",
        link: "https://midnapore.tigps.in/"
      },
      {
        title: "TIGPS - Nabadwip",
        desc: (
          <p>
            "TIGPS Nabadwip is a CBSE-affiliated co-educational English medium school established in 2015 in Nabadwip, West Bengal. The school aims to impart quality education and inculcate good values in future generations.”
          </p>
        ),
        img: "/images/ecosystem/Nabadwip.jpg",
        link: "https://nabadwip.tigps.in/"
      },
      {
        title: "TIGPS - Raiganj",
        desc: (
          <p>
            "TIGPS Raniganj is a CBSE-affiliated co-educational English medium school established in Raniganj, West Bengal. The school focuses on imparting value-based education and encourages students to participate in various extracurricular activities.”
          </p>
        ),
        img: "/images/ecosystem/Raniganj.jpg",
        link: "https://raniganj.tigps.in/"
      },
      {
        title: "TIGPS - Raniganj",
        desc: (
          <p>
            "TIGPS Raniganj is a CBSE-affiliated co-educational English medium school established in Raniganj, West Bengal. The school focuses on imparting value-based education and encourages students to participate in various extracurricular activities.”
          </p>
        ),
        img: "/images/ecosystem/Raniganj.jpg",
        link: "https://raniganj.tigps.in/"
      },

      {
        title: "TIGPS - Siliguri",
        desc: (
          <p>
            " TIGPS Siliguri is a CBSE-affiliated co-educational English medium school established in 2006 in Siliguri. TIGPS Siliguri has a well-equipped campus with modern facilities, including smart classrooms and well-equipped labs.”
          </p>
        ),
        img: "/images/ecosystem/Siliguri.jpg",
        link: "https://siliguri.tigps.in/"
      }
    ],

    college: [
      {
        title: "Netaji Subhash Engineering College",
        desc: (
          <p>
            "Netaji Subhash Engineering College (NSEC) is a prestigious engineering college located in Kolkata, West Bengal. Established in 1998, NSEC is affiliated with (MAKAUT), (NAAC) and (NBA)”
          </p>
        ),
        img: "/images/ecosystem/NSEC.jpg",
        link: "https://www.nsec.ac.in/"
      },
      {
        title: "Siliguri Institute Of Technology",
        desc: (
          <p>
            "Siliguri Institute of Technology (SIT) is a private engineering and management college established in 1999. SIT offers a range of courses including B.Tech, MBA, MCA, BBA, and BCA.”
          </p>
        ),
        img: "/images/ecosystem/SIT.jpg",
        link: "http://www.sittechno.org/"
      },
      {
        title: "Meghnad Saha Institute of Technology",
        desc: (
          <p>
            "Meghnad Saha Institute of Technology (MSIT) is a private engineering college located in Kolkata, Established in 2009. MSIT has a well-equipped campus with modern facilities.”
          </p>
        ),
        img: "/images/ecosystem/MSIT.jpg",
        link: "https://msit.edu.in/"
      },
      {
        title: "Techno International Batanagar",
        desc: (
          <p>
            "Techno International Batanagar (TIB) is a private engineering college located in Batanagar, West Bengal. Established in 2012. The college is affiliated with MAKAUT and AICTE.”
          </p>
        ),
        img: "/images/ecosystem/Batanagar.jpg",
        link: "https://tib.edu.in/"
      },
      {
        title: "Techno International New Town",
        desc: (
          <p>
            "Techno International New Town (TINT) is a private engineering college located in Kolkata, West Bengal. Established in 2005, TINT has a well-equipped campus with modern facilities.”
          </p>
        ),
        img: "/images/ecosystem/TINT.jpg",
        link: "https://tint.edu.in/"
      },
      {
        title: "Centre For Innovative Studies",
        desc: (
          <p>
            "Centre for Innovative Studies (CIS) is located at University of North Bengal Campus. A joint collaboration of University of North Bengal & Techno India Group.”
          </p>
        ),
        img: "/images/ecosystem/CIS.jpg",
        link: "https://www.cistechno.org/"
      }
    ],

    university: [
      {
        title: "Sister Nivedita University",
        desc: (
          <p>
            "Ever since starting off its glorious journey in 2017 amidst widespread attention, Sister
            Nivedita University has only scaled greater heights with the passage of every academic
            session. From shaping the future leaders of innovation and functioning as a reliable
            talent-pipeline for the fast-changing, tech-fuelled industry, to facilitating exemplary
            advancements in fundamental research, SNU is now a role model for private universities
            in India. The sheer impact it has made in women’s higher-education over the last decade,
            has drawn numerous accolades from academia as well as, industry leaders.”
          </p>
        ), img: "/images/ecosystem/SNU.jpg",
        link: "https://snuniv.ac.in/"
      },
      {
        title: "Techno India University Tripura",
        desc: (
          <p>
            "Within just three years from its inception, Techno India University, Tripura (TIUT), has
            made a name for itself in the world of academia as well as, in the industry at large. The
            institution has been offering a wide range of carefully-curated courses, which aims at
            fostering leadership skills and facilitates fundamental research along with significant
            advancements in the area of innovation & experiments. Graduates from TIUT, have been
            placed in the leading companies, across the globe and continue to make a difference with
            their critical thinking and exceptional skill set. ​”
          </p>
        ), img: "/images/ecosystem/ecosystem.png",
        link: "https://www.tiut.ac.in/"
      }
    ],
  };

  return (
    <div>
      <div className="inner-banner-wrapper">
        <img
          src="/images/page-banner/gallery.png"
          alt="Banner"
          className="inner-banner-img"
        />
        <div className="inner-banner-overlay">
          <div className="inner-banner-text">Education</div>
        </div>
      </div>

      <div className="overview-container">
        <div className="ecosystem-tab-buttons">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              className={activeTab === tab.key ? "ecosystem-active" : ""}
              onClick={() => changeTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className={`contain-body ${fade ? "fade-in" : "fade-out"}`}>
          {data[activeTab].map((item, index) => (
            <div
              key={index}
              className={`card-wrapper ${index % 2 ? "reverse" : ""}`}
            >
              <div className="card-text">
                <h2>{item.title}</h2>
                {item.desc}

                <a
                  href={item.link}
                  target="_blank"
                  rel="noreferrer"
                  className="learn-more-link"
                >
                  <span className="learn-more-icon">➜</span>
                  <span>Learn more</span>
                </a>
              </div>

              <div className="card-image">
                <img src={item.img} alt={item.title} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EducationPage;